export default __webpack_public_path__ + "static/media/snotificationicon.26c3676f.svg";